module.exports = __webpack_public_path__ + "img/sld_transformer_delta_star.12c3f82a.svg";